import React from 'react'
import '../scss/variables.scss'
import '../scss/reset.scss'
import './Join.scss'
import NavbarArrow from '../components/NavbarArrow/NavbarArrow'
import Footer from '../components/Footer/Footer'
import Sidemenu from '../components/Sidemenu/Sidemenu'

import goIcon from '../assets/images/goIcon.svg'



class Create extends React.Component {

    render() {
        let arrowPath = "/stanze";

        const joinRoomFunction = () => {
            let link = document.getElementById("pasteTextarea").value;
            console.log(link);
            document.getElementById('iframe').src = link;
        }

        return (
            <>
                <Sidemenu path1="/chi-siamo" name1="Chi Siamo" path2="/progetto" name2="Il Progetto" path3="/supportaci" name3="Supportaci" path4="/community" name4="Community" />
                <NavbarArrow arrowPath={arrowPath} />
                <main className="mainCreate">
                    <h1>Unisciti</h1>
                    <div className="pasteBar">
                        <div className="pastePart">
                            <textarea name="pastebar" id="pasteTextarea" cols="30" rows="10"></textarea>
                        </div>
                        <div className="joinPart" onClick={joinRoomFunction}>
                            <img src={goIcon} alt="UNISCITI" className="joinIcon" />
                        </div>
                    </div>   
                    <div className="meetContainer">                
                        <iframe title="iframe" src="" id="iframe" frameBorder="0"></iframe>
                    </div> 
                </main>
                {/* ADSENSE ads */}
                <div className="ad" align="center">
                    <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3763146420917084"
                    crossOrigin="anonymous"></script>
                </div>
                <Footer />
            </>
        )
    }

    
}

export default Create
